import { render, staticRenderFns } from "./CustomerDetailWaivers.vue?vue&type=template&id=438b32e2&"
import script from "./CustomerDetailWaivers.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailWaivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports